exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "section {\r\n    height: 500px;\r\n    overflow-y: auto;\r\n    padding-top: 20px;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/products/product-detail/link-benefit-modal/link-benefit-modal.component.css
// module id = 557
// module chunks = 0